import { useEffect, useRef, useState } from "react";
import styles from "./TextArea.module.scss";
import AutoLinkText from "./AutoLinkText";
import { images_path } from "../../constants";
import { getFileName } from "../../utils/genericUtils";
import FilesComponent from "./FilesComponent";

const TextArea = ({
  value,
  attachments,
  onChange,
  onSave,
  onAttach,
  onUnattach,
  placeholder,
}) => {
  const [editMode, setEditMode] = useState(false);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles([...files, file]);
      onAttach(file);
    }
  };

  useEffect(() => {
    if (attachments) {
      setFiles(attachments);
    }
  }, [attachments]);

  return (
    <>
      {editMode ? (
        <div className={styles.description_text_area_container}>
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={styles.description_text_area}
          ></textarea>
          <div className={styles.buttons_div}>
            <div className={styles.attach_file_div}>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              {/* <button
                className="text_link"
                onClick={() => fileInputRef.current.click()}
              >
                Allega file
                <img
                  className={styles.attach_image}
                  src={images_path + "attach.svg"}
                ></img>
              </button> */}
            </div>
            <button onClick={() => setEditMode(false)} className="button">
              Annulla
            </button>
            <button
              onClick={() => {
                setEditMode(false);
                onSave();
              }}
              className="button_var1"
            >
              Salva
            </button>
          </div>
        </div>
      ) : value ? (
        <div onClick={() => setEditMode(true)} className={styles.description}>
          <AutoLinkText text={value} />
        </div>
      ) : (
        <div
          onClick={() => setEditMode(true)}
          className={styles.add_description}
        >
          Aggiungi descrizione...
        </div>
      )}
      <FilesComponent
        fileObjects={attachments}
        onOpen={() => {}}
        onDelete={(file) => {
          onUnattach(file);
        }}
      />
    </>
  );
};

export default TextArea;
